module.exports = __webpack_public_path__ + "media/images/cardboard-bg-03-1-bf3450ac53faffb460b7653276ea8e4e.png";